import { render, staticRenderFns } from "./FooterText.vue?vue&type=template&id=2ae653d4&scoped=true&"
import script from "./FooterText.vue?vue&type=script&lang=js&"
export * from "./FooterText.vue?vue&type=script&lang=js&"
import style0 from "./FooterText.vue?vue&type=style&index=0&id=2ae653d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae653d4",
  null
  
)

export default component.exports